import React from "react";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

const ScheduleDeleteDialog = ({
  open,
  onOpenChange,
  deleteHasAssignments,
  deleteAssignmentMessage,
  handleDeleteSchedule,
}) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("planning.scheduleManager.deleteDialog.title")}</AlertDialogTitle>
        {deleteHasAssignments ? (
          <AlertDialogDescription className="text-orange-400 bg-orange-950/20 border border-orange-900/40 rounded p-3 mt-2">
            {deleteAssignmentMessage || t("planning.scheduleManager.deleteDialog.assignedMessage")}<br />
            <span className="font-medium">{t("planning.scheduleManager.deleteDialog.assignedWarning")}</span>
          </AlertDialogDescription>
        ) : (
          <AlertDialogDescription>
            {t("planning.scheduleManager.deleteDialog.description")}
          </AlertDialogDescription>
        )}
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t("planning.scheduleManager.actions.cancel")}</AlertDialogCancel>
        <AlertDialogAction
          onClick={() => handleDeleteSchedule(deleteHasAssignments)}
          className="bg-red-600 hover:bg-red-700"
        >
          {deleteHasAssignments ? t("planning.scheduleManager.deleteDialog.deleteWithAssignments") : t("planning.scheduleManager.actions.delete")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  );
};

export default ScheduleDeleteDialog;
